import React from 'react'
import { FormattedMessage } from 'react-intl'
import { ReactComponent as ProjectMoveTo } from '@mike/mike-shared-frontend/media/icons/ProjectMoveTo'
import { ButtonProps as MuiButtonProps } from '@mui/material/Button'

import { iconSecondaryStyle, StyledIconButton } from './iconStyles'

const MoveToButton = (buttonProps: MuiButtonProps) => {
  return (
    <StyledIconButton {...buttonProps}>
      <ProjectMoveTo className={iconSecondaryStyle(buttonProps.disabled)} />
      <FormattedMessage id={'projectContent.moveToButton'} />
    </StyledIconButton>
  )
}

export default MoveToButton
